import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Heart } from 'lucide-react';
export function PriceClose() {
  return <section id="pricing" className="py-14 px-6 bg-[#F5E6D0]/20 relative overflow-hidden" data-id="element-77">
      {/* Decorative blobs */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-78">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#C4704B] rounded-full mix-blend-multiply filter blur-3xl opacity-5" data-id="element-79" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-[#8B9E7E] rounded-full mix-blend-multiply filter blur-3xl opacity-5" data-id="element-80" />
      </div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-82">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3A4A] mb-6 font-serif" data-id="element-83">
            Una inversión en tu paz mental
          </h2>
          <p className="text-lg text-[#2D3A4A]/70 mb-6" data-id="element-84">
            La Agenda Anti-Pantallas cuesta menos que:
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-85">
            {['Un juguete que dura 3 días', 'Una salida improvisada', 'Una compra por culpa'].map((item, i) => <span key={i} className="bg-white px-4 py-2 rounded-full text-sm text-[#2D3A4A] shadow-sm border border-[#F5E6D0]" data-id="element-86">
                {item}
              </span>)}
          </div>
        </motion.div>

        <motion.div id="price-card" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-[2.5rem] shadow-xl overflow-hidden border border-[#F5E6D0] relative" data-id="element-87">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#C4704B] to-[#8B9E7E]" data-id="element-88" />

          <div className="p-8 md:p-12 text-center" data-id="element-89">
            <h3 className="text-2xl font-bold text-[#2D3A4A] mb-2" data-id="element-90">
              Agenda Anti-Pantallas
            </h3>
            <p className="text-[#2D3A4A]/60 mb-6" data-id="element-91">
              Edición 1–4 años • Digital PDF
            </p>

            <div className="flex items-center justify-center mb-8" data-id="element-92">
              <span className="text-5xl font-bold text-[#2D3A4A]" data-id="element-93">$17</span>
              <span className="text-xl text-[#2D3A4A]/50 ml-2" data-id="element-94">USD</span>
            </div>

            <ul className="text-left max-w-xs mx-auto space-y-3 mb-10" data-id="element-95">
              <li className="flex items-center text-[#2D3A4A]/80" data-id="element-96">
                <ShieldCheck className="w-5 h-5 text-[#8B9E7E] mr-3" data-id="element-97" />
                Acceso inmediato de por vida
              </li>
              <li className="flex items-center text-[#2D3A4A]/80" data-id="element-98">
                <ShieldCheck className="w-5 h-5 text-[#8B9E7E] mr-3" data-id="element-99" />
                30 días de planificación lista
              </li>
              <li className="flex items-center text-[#2D3A4A]/80" data-id="element-100">
                <ShieldCheck className="w-5 h-5 text-[#8B9E7E] mr-3" data-id="element-101" />
                Sin necesidad de imprimir
              </li>
            </ul>

            <a id="buy-button" href="https://factorclaro.com/cart/45275718320307:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto px-10 py-4 bg-[#C4704B] text-white text-lg font-bold rounded-full hover:bg-[#A65D3D] transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-xl flex items-center justify-center mx-auto group no-underline" data-id="element-102">
              Quiero empezar hoy
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-103" />
            </a>
            <p className="mt-4 text-xs text-[#2D3A4A]/40" data-id="element-104">
              Pago seguro • Garantía de satisfacción
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-12 text-center max-w-2xl mx-auto" data-id="element-105">
          <Heart className="w-10 h-10 text-[#C4704B] mx-auto mb-4 opacity-80" data-id="element-106" />
          <h3 className="text-2xl md:text-3xl font-serif text-[#2D3A4A] mb-4" data-id="element-107">
            No te prometo una casa silenciosa.
          </h3>
          <p className="text-lg text-[#2D3A4A]/80 leading-relaxed mb-4" data-id="element-108">
            Te prometo algo más útil: Que cuando llegue el momento crítico del
            día, no tengas que pensar.
          </p>
          <p className="text-lg text-[#2D3A4A]/80 leading-relaxed" data-id="element-109">
            Abrís la agenda. Hacés 15 minutos. <br data-id="element-110" />Y te vas a dormir con una
            sensación que hoy te está faltando:
          </p>
          <p className="text-2xl font-serif italic text-[#C4704B] mt-6" data-id="element-111">
            "Hoy hice algo bien."
          </p>
        </motion.div>
      </div>
    </section>;
}